import MonthScreenDal from '../dal/MonthScreen';

class MonthScreen {
    static async getMonthData(URL, requestOption) {
        return await MonthScreenDal.getMonthData(URL, requestOption);
    }
}
export default MonthScreen;